import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, DatePicker, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { supabase } from "../supabase";

const DailyReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingReport, setEditingReport] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const { data, error } = await supabase.from("daily_reports").select("*");
      if (error) throw error;
      setReports(data);
    } catch (error) {
      message.error("Error fetching reports");
    } finally {
      setLoading(false);
    }
  };

  const showModal = (report = null) => {
    setEditingReport(report);
    setIsModalVisible(true);
    if (report) {
      form.setFieldsValue(report);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      if (editingReport) {
        const { error } = await supabase
          .from("daily_reports")
          .update(values)
          .eq("id", editingReport.id);
        if (error) throw error;
        message.success("Report updated successfully");
      } else {
        const { error } = await supabase.from("daily_reports").insert([values]);
        if (error) throw error;
        message.success("Report added successfully");
      }
      fetchReports();
      handleCancel();
    } catch (error) {
      message.error("Error saving report");
    }
  };

  const columns = [
    {
      title: "Report Date",
      dataIndex: "report_date",
      key: "report_date",
    },
    {
      title: "Summary",
      dataIndex: "summary",
      key: "summary",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => showModal(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => showModal()}
        style={{ marginBottom: 16 }}
      >
        Add Report
      </Button>
      <Table columns={columns} dataSource={reports} loading={loading} rowKey="id" />
      <Modal
        title={editingReport ? "Edit Report" : "Add Report"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="report_date"
            label="Report Date"
            rules={[{ required: true, message: "Please select the report date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item
            name="summary"
            label="Summary"
            rules={[{ required: true, message: "Please input the summary!" }]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DailyReports;
